import { ThermostatWorkingMode } from './HvacControl';
export var ThermostatLabel;
(function (ThermostatLabel) {
    ThermostatLabel["DEVICE_NAME"] = "Device Name";
    ThermostatLabel["DESCRIPTION"] = "Description";
    ThermostatLabel["UUID"] = "UUID";
    ThermostatLabel["SITE"] = "Site";
    ThermostatLabel["LOCATION"] = "Space";
    ThermostatLabel["NETWORK_GROUP"] = "Network Group";
    ThermostatLabel["WIRELESS_TEMPERATURE_SENSORS_COUNT"] = "Wireless Temperature Sensors";
})(ThermostatLabel || (ThermostatLabel = {}));
export var ThermostatStatusLabel;
(function (ThermostatStatusLabel) {
    ThermostatStatusLabel["STATUS"] = "Status";
    ThermostatStatusLabel["THERMOSTAT_STATUS"] = "Thermostat Status";
    ThermostatStatusLabel["SIGNAL"] = "Signal";
})(ThermostatStatusLabel || (ThermostatStatusLabel = {}));
export var ThermostatSettingsLabel;
(function (ThermostatSettingsLabel) {
    ThermostatSettingsLabel["SENSOR_SOURCE"] = "Sensor Source";
    ThermostatSettingsLabel["DISPLAY_NAME"] = "Display Name";
    ThermostatSettingsLabel["WIRELESS_SENSORS"] = "Wireless Sensors";
    ThermostatSettingsLabel["SENSOR_SOURCE_FALLBACK"] = "Sensor Source Fallback";
    ThermostatSettingsLabel["SENSOR_SOURCE_FALLBACK_TIME"] = "Sensor Source Fallback Time";
    ThermostatSettingsLabel["DEADBAND_SETTING"] = "Deadband Setting";
    ThermostatSettingsLabel["COMPRESSOR_PROTECTION"] = "Compressor Protection";
    ThermostatSettingsLabel["HUMIDITY_SETTINGS"] = "Humidity Settings";
})(ThermostatSettingsLabel || (ThermostatSettingsLabel = {}));
export var ScreenLockLabel;
(function (ScreenLockLabel) {
    ScreenLockLabel["true"] = "Locked";
    ScreenLockLabel["false"] = "Unlocked";
})(ScreenLockLabel || (ScreenLockLabel = {}));
export var ThermostatLiveStatusLabel;
(function (ThermostatLiveStatusLabel) {
    ThermostatLiveStatusLabel["ONLINE_STATUS"] = "Status";
    ThermostatLiveStatusLabel["THERMOSTAT_TEMPERATURE"] = "Thermostat Temperature";
    ThermostatLiveStatusLabel["BATTERY_LEVEL"] = "Battery Level";
    ThermostatLiveStatusLabel["DETECTED_SENSORS"] = "Detected Sensors";
    ThermostatLiveStatusLabel["NUMBER_OF_SENSORS"] = "Number of Sensors";
    ThermostatLiveStatusLabel["MIN_TEMP"] = "Heat To";
    ThermostatLiveStatusLabel["MAX_TEMP"] = "Cool To";
    ThermostatLiveStatusLabel["THERMOSTAT_MODE"] = "Thermostat Mode";
    ThermostatLiveStatusLabel["FAN_MODE"] = "Fan Mode";
    ThermostatLiveStatusLabel["THERMOSTAT_DISPLAY"] = "Thermostat Display";
    ThermostatLiveStatusLabel["HEATING_STAGE_1"] = "Heating Stage 1 (W1)";
    ThermostatLiveStatusLabel["HEATING_STAGE_2"] = "Heating Stage 2 (W2)";
    ThermostatLiveStatusLabel["COOLING_STAGE_1"] = "Cooling Stage 1 (Y1)";
    ThermostatLiveStatusLabel["COOLING_STAGE_2"] = "Cooling Stage 2 (Y2)";
    ThermostatLiveStatusLabel["FAN_OUTPUT"] = "Fan Output (G)";
})(ThermostatLiveStatusLabel || (ThermostatLiveStatusLabel = {}));
export const mapThermostatFieldToLabel = {
    title: ThermostatLabel.DEVICE_NAME,
    description: ThermostatLabel.DESCRIPTION,
    uuid: ThermostatLabel.UUID,
    siteId: ThermostatLabel.SITE,
    spaceId: ThermostatLabel.LOCATION,
    networkGroupId: ThermostatLabel.NETWORK_GROUP,
    wirelessTemperatureSensorsCount: ThermostatLabel.WIRELESS_TEMPERATURE_SENSORS_COUNT,
};
export const ThermostatWorkingModeMap = {
    0: ThermostatWorkingMode.OFF,
    1: ThermostatWorkingMode.HEATING,
    2: ThermostatWorkingMode.COOLING,
    3: ThermostatWorkingMode.AUTO,
};
